import React from 'react';

const EmojiPickerModal = ({
  isOpen,
  onClose,
  onInsertEmoji
}) => {
  if (!isOpen) return null;

  const emojis = [
    "😀", "😃", "😄", "😁", "😆", "😅", "😂", "🤣",
    "😊", "😇", "🙂", "🙃", "😉", "😌", "😍", "🥰",
    "😘", "😗", "😙", "😚", "😋", "😛", "😝", "😜",
    "🤪", "🤨", "🧐", "🤓", "😎", "🤩", "🥳", "😏",
    "😒", "😞", "😔", "😟", "😕", "🙁", "☹️", "😣",
    "😖", "😫", "😩", "🥺", "😢", "😭", "😤", "😠",
    "👍", "👎", "👌", "🤝", "👏", "🙌", "👐", "🤲",
    "🙏", "✍️", "💪", "🦾", "🦿", "🦵", "🦶", "👂",
    "🎉", "🎊", "🎈", "🎁", "🎀", "🎂", "🍰", "🧁",
    "🍭", "🍬", "🍫", "🍩", "🍪", "☕", "🍵", "🥤",
    "❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍",
    "🤎", "💔", "❣️", "💕", "💞", "💓", "💗", "💖",
    "⭐", "🌟", "💫", "✨", "🌈", "☀️", "🌤️", "⛅",
    "🌦️", "🌧️", "⛈️", "🌩️", "🌨️", "❄️", "☃️", "⛄"
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96 max-h-96 overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold">Insert Emoji</h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            ×
          </button>
        </div>
        <div className="grid grid-cols-8 gap-2">
          {emojis.map((emoji, index) => (
            <button
              key={index}
              onClick={() => onInsertEmoji(emoji)}
              className="p-2 text-xl hover:bg-gray-100 rounded transition-colors"
              title={emoji}
            >
              {emoji}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EmojiPickerModal;